<template>
    <CountryFlag :country="country" />
</template>

<script>
import CountryFlag from './CountryFlag';
import { languageToCountry } from '../../js/ViewFormatter/LanguageToCountry';

export default {
    components: { CountryFlag },
    props: {
        language: {
            type: String,
            required: true,
            validator: function (value) {
                return ['nl', 'en', 'de', 'es', 'fr', 'it', 'da', 'no', 'sv', 'fi', 'au', 'us', 'gb', 'en_GB', 'en_US', 'en_AU', 'de_AT', 'de_CH'].indexOf(value) !== -1;
            },
        },
    },
    computed: {
        country: function () {
            return languageToCountry(this.language);
        },
    },
};
</script>
